export class DocumentHelper 
{

    static loadExternalScript(url: string, obj?: any, callback?: string) 
    {
        const myScriptElement = document.createElement('script');
        myScriptElement.src = url;
        myScriptElement.type = 'text/javascript';
        myScriptElement.async = true;

        myScriptElement.onload = () => {
            if (callback && obj) 
            {
                obj[callback]();
            }
        };

        document.body.appendChild(myScriptElement);
    }
}